import { CreditCard, CreditCardType } from "../types/CreditCard";
import { startNumberElo } from "../constants";
import CreditCards from "../functions/creditCards";

export class CreditCardElo implements CreditCard {
    getType(): CreditCardType {
        return CreditCardType.Elo;
    }
    compare(number?: string): boolean {
        return CreditCards.compare(startNumberElo, number);
    }
    getImageUrl() {
        return `${process.env.REACT_APP_PAY_HOST}/assets/creditcards/elo.png`;
    }
}